import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Carousel from '@nerdwallet/react-carousel';
import { Impression } from '@nerdwallet/analytics/react/impression';
import TestimonialTile from './testimonial-tile';
import {
  HOMEPAGE as analyticsBase,
  HOMEPAGE_SEGMENT_INSTRUMENTATION,
} from '../../../lib/analytics-constants';

import styles from './testimonials.module.less';
import SegmentImpression from '../../segment-impression';
import useAnalytics from '~/client/lib/segment/useAnalytics';

const Testimonials = ({ tiles }) => {
  const renderedTiles = _.map(tiles, (tile, nav) => (
    <TestimonialTile {...tile} key={`item-${nav}`} />
  ));

  const { trackSegmentTrackEvent } = useAnalytics();
  return (
    <SegmentImpression
      eventName="Element Impression"
      eventProps={HOMEPAGE_SEGMENT_INSTRUMENTATION.testimonials}
    >
      <Impression
        entityName={analyticsBase.entity_names.testimonials}
        payload={{
          section_name: analyticsBase.section_name,
          registration_cohort: analyticsBase.cohort,
        }}
      >
        <div className={styles.testimonialsContainer}>{renderedTiles}</div>
        <div>
          <Carousel
            id="testimonials"
            entityName="testimonials"
            decorateNav={false}
            enableDotNavigation
            arrows={false}
            dots
            inactiveDotColor="#000000"
            activeDotColor="#008255"
            slidesToShow="1.3"
            className={styles.testimonialsCarousel}
            onSwipe={() =>
              trackSegmentTrackEvent('Element Interaction', {
                entity_name:
                  HOMEPAGE_SEGMENT_INSTRUMENTATION.carousel_testimonials
                    .entity_name,
                location:
                  HOMEPAGE_SEGMENT_INSTRUMENTATION.carousel_testimonials
                    .location,
                sub_location:
                  HOMEPAGE_SEGMENT_INSTRUMENTATION.carousel_testimonials
                    .sub_location,
                action: 'select',
              })
            }
          >
            {renderedTiles}
          </Carousel>
        </div>
      </Impression>
    </SegmentImpression>
  );
};

Testimonials.displayName = 'Testimonials';

Testimonials.propTypes = {
  tiles: PropTypes.arrayOf(PropTypes.shape(TestimonialTile.propTypes)),
};

export default Testimonials;
